import { Link } from 'react-router-dom'

import LinkedInIcon from '../_icons/LinkedInIcon'
import { FOOTER_LINKS } from './constants'

const Footer = (): JSX.Element => {
	return (
		<footer className=" bg-white px-10 py-8 text-beep-grey md:px-20 md:py-12 lg:py-16">
			<div className="grid grid-cols-1 gap-3 md:grid-cols-4">
				<div className="mb-4 grid grid-cols-1 gap-6 md:col-span-1 md:col-start-1 lg:mb-0">
					<img src="/svg/assets/VoltalityLogo.svg" alt="logo" width={606 / 2.2} height="auto" />
					<div className="flex items-center justify-between gap-2 md:flex-col md:items-start md:gap-6 xl:flex-row xl:items-center xl:gap-5">
						<img src="/assets/footer/iso_27001.png" alt="iso27001" width={67} height="auto" />
						<hr className="h-full border-l border-gray-200 md:hidden xl:block" />
						<div className="text-xs">
							Voltality is the wholly owned subsidiary of Beep Technologies Pte. Ltd. which is
							certified according to ISO27001.
						</div>
					</div>
				</div>

				<div className="grid grid-cols-2 gap-y-6 md:col-span-3 md:col-start-2 md:flex md:grid-cols-4 md:justify-around">
					{FOOTER_LINKS.map((column, i) => (
						<div key={i}>
							<div>
								<div className="mb-4 mt-3 text-paragraph font-bold text-beep-black">
									{column.title}
								</div>
								<div className="grid justify-between">
									{column.links.map((link, j) => (
										<Link
											key={j}
											to={link.url}
											className="duration-400 my-2 text-beep-grey no-underline transition-colors ease-in-out hover:text-beep-cyan"
										>
											{link.heading}
										</Link>
									))}
								</div>
							</div>
						</div>
					))}
					<div>
						<div className="mb-6 ml-1 mt-3 text-paragraph font-bold text-beep-black">Follow Us</div>
						<div className="ml-1.5">
							<a
								href="https://linkedin.com/company/voltality"
								className="duration-400 cursor-pointer fill-current text-beep-black transition-colors ease-in-out hover:text-beep-cyan"
								target="_blank"
								rel="noreferrer"
								aria-label="Visit our LinkedIn page"
							>
								<LinkedInIcon className="w-5" />
							</a>
						</div>
					</div>
				</div>
			</div>

			<hr className="mb-6 mt-10 border-t border-gray-300" />
			<div className="mb-10">Copyright 2024 Voltality. All rights reserved.</div>
		</footer>
	)
}
export default Footer
